export const LOGIN = "LOGIN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const RESET_TOKEN = "RESET_TOKEN"
export const REGISTER = "REGISTER";
export const CUSTOMER_PROFILE = "CUSTOMER_PROFILE";
export const RESET_CUSTOMER = "RESET_CUSTOMER"
export const LANGUAGE = "LANGUAGE"
export const TRIGGER = "TRIGGER"
export const MAPKEY = "MAPKEY"